import {MovieService,AuthService} from 'hasta-la-vista-middleware-api/service'
export default {
    name: 'related_movies',
    props:{
        section:Object,
        first:Boolean,
    },
    data(){
        return{
            movies:null,
            loading:true,
            heading:"Movies now showing",
        }
    },

    methods:{
        getRelatedMovies(movies, user) {
            if (!user || user.isGuest() || user.PreferredGenres.length == 0) {
                return movies;
            };
            this.heading = "Movies we think you'll enjoy";
            let filteredMovies = []
            movies.reduce((c, movie)=> {
                movie.genres.forEach((genre)=> {
                    user.PreferredGenres.forEach((prefGen)=> {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie)
                        }
                    })
                })
            })
            return filteredMovies
        }
    },

    created(){
        Promise.all([AuthService.user(),MovieService.getMovies()]).then(([user,m])=>{
            this.movies = this.getRelatedMovies(m.byRelease().now_showing,user);
            this.loading = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/content/related_movies/related_movies.js